import * as React from 'react';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { getContactName } from '../../utils/DataFormatterUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';

interface ContactAvatarWithNameEmailProps {
	contact: any;
	// Shown when no hydrated contact is available (e.g. the raw *ByEmail string).
	fallbackEmail?: string;
	size?: 'small' | 'default' | 'large';
}

// Compact contact display: the avatar image (or initials) alongside the contact's name and email.
export const ContactAvatarWithNameEmail: React.FC<ContactAvatarWithNameEmailProps> = ({
	contact,
	fallbackEmail = '',
	size = 'default',
}) => {
	if (!contact) {
		return <span className="bodyregular text-character-primary">{fallbackEmail || '—'}</span>;
	}
	const name = getContactName(contact).trim();
	const email = nullSafeGet('email', contact) || fallbackEmail;
	return (
		<div className="flex flex-row items-center" style={{ gap: '8px' }}>
			<ContactAvatar hidePopover size={size} contact={contact} />
			<div className="flex flex-col">
				<span className="bodyregular text-character-primary">{name || fallbackEmail || '—'}</span>
				{email ? <span className="footnoteregular text-character-secondary">{email}</span> : null}
			</div>
		</div>
	);
};
